import React from "react";
import PageTitle from "../../../components/page-title";
import PropTypes from "prop-types";

const PageTitleContainer = ({ subTitle, title, image, variant }) => {
    const publicUrl = process.env.PUBLIC_URL;

    if (variant === "academic") {
        return (
            <div className="page-title-area-academic">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-10 m-auto" data-aos="fade-up">
                            <div className="academic-journal-header">
                                <p className="journal-meta">{subTitle}</p>
                                <h2 className="academic-title" dangerouslySetInnerHTML={{ __html: title }}></h2>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="page-title-area bg-img bg-img-top" style={{ backgroundImage: `url(${publicUrl}/${image})` }}>
            <div className="container">
                <div className="row">
                    <div className="col-lg-6 col-xl-7 m-auto" data-aos="fade-up">
                        <PageTitle subTitle={subTitle} title={title} />
                    </div>
                </div>
            </div>
        </div>
    );
};

PageTitleContainer.propTypes = {
    subTitle: PropTypes.string,
    title: PropTypes.string,
    image: PropTypes.string,
    variant: PropTypes.string,
};

export default PageTitleContainer;
